/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEquipment
 */
export interface CreateEquipment {
    /**
     * 
     * @type {string}
     * @memberof CreateEquipment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipment
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEquipment
     */
    imageId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEquipment
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEquipment
     */
    hasWeight?: boolean;
}

/**
 * Check if a given object implements the CreateEquipment interface.
 */
export function instanceOfCreateEquipment(value: object): value is CreateEquipment {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateEquipmentFromJSON(json: any): CreateEquipment {
    return CreateEquipmentFromJSONTyped(json, false);
}

export function CreateEquipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEquipment {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'hasWeight': json['hasWeight'] == null ? undefined : json['hasWeight'],
    };
}

export function CreateEquipmentToJSON(json: any): CreateEquipment {
    return CreateEquipmentToJSONTyped(json, false);
}

export function CreateEquipmentToJSONTyped(value?: CreateEquipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'isPublic': value['isPublic'],
        'hasWeight': value['hasWeight'],
    };
}

